import AssetField from '../../../contentful/AssetField';
import FileAssetField from '../../../contentful/FileAssetField';
import update from 'immutability-helper';
import React from 'react';
import cookie from 'js-cookie';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import EntityCollectionField from '../../../contentful/EntityCollectionField';
import ReactJson from 'react-json-view';
import Entity from '../../../contentful/Entity';

class EquipmentFactoryComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleIncludedEquipmentChange = this.handleIncludedEquipmentChange.bind(this);
  }

  componentDidMount() {
    const tab = cookie.get('mgEquipmentFactoryTab');
    if (tab !== '' && tab !== undefined && document.getElementById(tab)) {
      const tabLink = document.getElementById(tab);
      tabLink.click();
    }
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      equipmentFactory: {}
    };

    change.equipmentFactory[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    if (e.target.type === 'checkbox') {
      return this.handleAssetChange(e.target.name, e.target.checked);
    }

    return this.handleAssetChange(e.target.name, e.target.value);
  }

  setTabCookie(e) {
    const tabLink = e.target.id;
    const cookieName = 'mgEquipmentFactoryTab';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  handleIncludedEquipmentChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    // Check if the included equipment is a package or not. We currently
    // do not support packages in packages so we will have to block it here.
    const assetItem = asset[asset.length - 1] ?? null;
    if (assetItem) {
      if (assetItem.includedFactoryEquipment.length > 0) {
        this.props.setError('Systemet tillater ikke pakker i pakker. Vennligst velg et annet utstyr, eller fjern alt utstyr fra pakken du prøvde å legge til');
        throw new Error('Systemet tillater ikke pakker i pakker. Vennligst velg et annet utstyr, eller fjern alt utstyr fra pakken du prøvde å legge til');
      }
    }

    this.handleFieldChange(event);
  }

  render() {
    const equipmentFactory = this.props.equipmentFactory;
    const priceValue = `${equipmentFactory.price},-`;
    const linkedEntries = this.props.linkedEntries;

    // IDs excluded from the search, so that it is not possible to add itself, or items already in the package.
    const excludedIDs = [equipmentFactory.id, ...equipmentFactory.includedFactoryEquipment.map((item) => item.id)];

    const predefinedTags = [this.props.model.make.name, this.props.model.name, 'Ekstrautstyr'];

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link>
          </li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link>
          </li>
          <li className="active">{equipmentFactory.nameCustom || equipmentFactory.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {equipmentFactory.nameCustom || equipmentFactory.name} <PublishStatusDot entry={equipmentFactory} /><br/>
                  <small>Ekstrautstyr</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!equipmentFactory.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(equipmentFactory.draft || equipmentFactory.updated) || this.props.working || this.props.modified || equipmentFactory.archived}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={equipmentFactory.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!equipmentFactory.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {equipmentFactory.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#general" id="generalTab" data-target="#general" aria-controls="general" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Generelt</a></li>
            <li role="presentation"><a href="#contents" id="contentsTab" data-target="#contents" aria-controls="contents" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Innhold</a></li>
          </ul>

          {/* Tab content */}
          <div className="tab-content mf-margin-bottom-40">
            {/* General tab */}
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <div className="form-group">
                    <label>Navn <small>{equipmentFactory.custom ? '' : '(Valgfri)'}</small></label>
                    <input type="text" className="form-control" name="nameCustom" placeholder={equipmentFactory.name} disabled={this.props.working || equipmentFactory.archived} defaultValue={equipmentFactory.nameCustom} onChange={this.handleFieldChange} />
                    {!equipmentFactory.custom &&
                    <span className="help-block">Om utfylt vil denne teksten overstyre navn fra Axapta.</span>
                    }
                  </div>
                  <div className="form-group">
                    <label>Beskrivelse <small>{equipmentFactory.custom ? '' : '(Valgfri)'}</small></label>
                    <textarea className="form-control" name="descriptionCustom" rows="10" placeholder={equipmentFactory.description} disabled={this.props.working || equipmentFactory.archived} defaultValue={equipmentFactory.descriptionCustom} onChange={this.handleFieldChange}></textarea>
                    {!equipmentFactory.custom &&
                    <span className="help-block">Om utfylt vil denne teksten overstyre beskrivelsen fra Axapta.</span>
                    }
                  </div>
                  <div className="form-group">
                    <label>MVA kalkulering</label>
                    {equipmentFactory.validVatOptions &&
                    <select
                      type="text"
                      className="form-control"
                      name="vatOption"
                      defaultValue={equipmentFactory.vatOption}
                      disabled={this.props.working || equipmentFactory.archived}
                      onChange={this.handleFieldChange}
                    >
                      <option value="">-- Velg utregning --</option>
                      {equipmentFactory.validVatOptions.map((group, key) => {
                        return <option key={key} value={group.value}>{group.name}</option>;
                      })}
                    </select>
                    }
                  </div>
                  <div className="form-group">
                    <label>Bilde</label>
                    <AssetField
                      name="image"
                      value={equipmentFactory.image}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || equipmentFactory.archived}
                      predefinedTags={predefinedTags}
                    />
                  </div>
                  <div className="form-group">
                    <label>Informasjonsfil</label>
                    <FileAssetField
                      name="informationFile"
                      value={equipmentFactory.informationFile}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || equipmentFactory.archived}
                      predefinedTags={predefinedTags}
                    />
                  </div>
                </div>
                <div className="col-xs-12 col-md-6">
                  {!equipmentFactory.custom &&
                  <div className="form-group">
                    <label>Navn</label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="name" defaultValue={equipmentFactory.name} disabled/>
                      <div className="input-group-addon">{equipmentFactory.custom ? '' : 'Data fra Axapta'}</div>
                    </div>
                  </div>
                  }
                  <div className="form-group">
                    <label>Kode</label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="equipmentCode" defaultValue={equipmentFactory.equipmentCode} disabled={!equipmentFactory.custom || (this.props.working || equipmentFactory.archived)} onChange={this.handleFieldChange}/>
                      <div className="input-group-addon">{equipmentFactory.custom ? '' : 'Data fra Axapta'}</div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Høyeste pris <small>(Uten mva)</small></label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="price" defaultValue={equipmentFactory.custom ? equipmentFactory.price : priceValue} disabled={!equipmentFactory.custom || (this.props.working || equipmentFactory.archived)} onChange={this.handleFieldChange}/>
                      <div className="input-group-addon">{equipmentFactory.custom ? '' : 'Data fra Axapta'}</div>
                    </div>
                    <span className="help-block">Pris kan variere per variant, se pris på varianter under.</span>
                  </div>
                  {!equipmentFactory.custom &&
                  <div className="form-group">
                    <label>Varianter (Data fra Axapta)</label>
                    {equipmentFactory.variantWhitelist.map((variant, i) => {
                      const info = <div>
                        <div>Pris: {Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(equipmentFactory.variantPrices[variant.modelCode])},-</div>
                      </div>;
                      return <Entity disabled={this.props.working || equipmentFactory.archived} allowEdit key={i} info={info} entity={variant} />;
                    })}
                  </div>
                  }
                  <div className="form-group">
                    <label>{equipmentFactory.custom ? 'Varianter' : 'Ekstra varianter'}</label>
                    <EntityCollectionField
                      name="variantWhitelistManual"
                      value={equipmentFactory.variantWhitelistManual}
                      contentType="variant"
                      searchParams={{
                        'fields.model.sys.id': this.props.model.id
                      }}
                      searchOnOpen={true}
                      allowEdit={true}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || equipmentFactory.archived }
                    />
                  </div>
                  <div className="form-group">
                    <label>Kun utvalgte forhandlere</label>
                    <EntityCollectionField
                      name="dealerWhitelist"
                      value={equipmentFactory.dealerWhitelist}
                      contentType="forhandler"
                      searchParams={{
                        'fields.makes.sys.id[in]': this.props.model.make.id
                      }}
                      quickAdd={true}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || equipmentFactory.archived }
                    />
                  </div>
                  {!equipmentFactory.custom && <div>
                    <div className="form-group hidden">
                      <label>Varenr</label>
                      <ReactJson
                        name={false}
                        src={equipmentFactory.variantOptionRef}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                      />
                    </div>
                    <div className="form-group hidden">
                      <label>Priser</label>
                      <ReactJson
                        name={false}
                        src={equipmentFactory.variantPrices}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                      />
                    </div>
                  </div>}
                  {this.props.model.make.slug === 'hongqi' && <>
                    <div className="form-group mf-margin-top-20">
                      <hr />
                      <label>Spesialbestilling</label>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="specialOrder" defaultChecked={equipmentFactory.specialOrder} onChange={this.handleFieldChange} disabled={this.props.working} />
                          Merk som spesialbestilling
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Spesialbestilling kun sammen med følgende farger</label>
                      <EntityCollectionField
                        name="colorsSpecialOrder"
                        value={equipmentFactory.colorsSpecialOrder}
                        contentType="color"
                        searchParams={{
                          'fields.model.sys.id': this.props.model.id
                        }}
                        searchOnOpen={true}
                        onChange={this.handleAssetChange}
                        disabled={equipmentFactory.specialOrder || this.props.working || equipmentFactory.archived }
                      />
                    </div>
                    <div className="form-group">
                      <label>Kun tilgjengelig med valgte farger</label>
                      <EntityCollectionField
                        name="colorWhitelist"
                        value={equipmentFactory.colorWhitelist}
                        contentType="color"
                        searchParams={{
                          'fields.model.sys.id': this.props.model.id
                        }}
                        searchOnOpen={true}
                        onChange={this.handleAssetChange}
                        disabled={this.props.working || equipmentFactory.archived }
                      />
                    </div>
                  </>}
                </div>
              </div>
            </div>

            {/* Contents tab */}
            <div role="tabpanel" className="tab-pane" id="contents">
              {linkedEntries.length > 0 && (
                <div className="alert alert-warning">
                  Kan ikke gjøre om utstyr til pakke siden utstyret ligger i en annen pakke allerede:
                  <ul>
                    {linkedEntries.map((entry) => (
                      <li key={entry.sys.id}>
                        <a href={`/${entry.sys.contentType.sys.id}/${entry.sys.id}`}>{entry.fields.name['nb-NO']}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {linkedEntries.length === 0 && (
                <div className="row">
                  <div className="col-xs-12 col-md-12">
                    <label>Inkludert fabrikkmontert ekstrautstyr</label>
                    <EntityCollectionField
                      name="includedFactoryEquipment"
                      value={equipmentFactory.includedFactoryEquipment}
                      contentType="equipmentFactory"
                      quickAdd={true}
                      searchParams={{
                        'fields.model.sys.id': this.props.model.id,
                        'fields.group[ne]': true,
                        'fields.includedEquipment[exists]': false,
                        'sys.id[nin]': excludedIDs.join(',')
                      }}
                      searchOnOpen={true}
                      onChange={this.handleIncludedEquipmentChange}
                      disabled={this.props.working || equipmentFactory.archived }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default EquipmentFactoryComponent;
